<template>
  <div class="edit-chapter-dailog dialog col-block">
    <customForm
      :init="chapter"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '20px' }"></div>
    <customForm
      :init="chapter"
      :alerts="alerts"
      :forms="formOptions['field2']"
      @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateSendChapter() : ''">
        <span>{{ chapter.id ? $t('COMMON.button.___save') : $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
// import { postChapter, putChapter } from '../../api'
import customForm from '../../components/tool/customForm'

export default {
  components: {
    customForm
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      chapter: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: this.param.chapter ? this.$t('DIALOG.editChapter.form.title.___title') : this.$t('DIALOG.editChapter.form.title.___newTitle'),
            value: 'title',
            type: 'input',
            placeholder: () => this.$t('DIALOG.editChapter.form.placeholder.___title'),
            validate: 'required'
          }
        ],
        field2: [
          {
            title: this.$t('DIALOG.editChapter.form.title.___description'),
            value: 'description',
            type: 'textarea',
            placeholder: () => this.$t('DIALOG.editChapter.form.placeholder.___description')
          }
        ]
      }
    }
  },
  created () {
    let chapter = this.param.chapter || this.chapter
    this.chapter = chapter
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.chapter)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateSendChapter () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.sendChapter()
      }
      this.onSubmit = false
    },
    async sendChapter () {
      try {
        this.$emit('changeModal', {}, this.result)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editChapter.vue